import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box/box.component';

import { DashboardsListView } from '@futrli/views/views/reports/DashboardsListView/DashboardsListView';
import { ListingPageHeader } from '@futrli/ui-components/components/listing-page/listing-page-header/listing-page-header';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { LISTING_PAGE_TABS_HEIGHT } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';

import { MyDashboardsFilterBar } from '../../../components/my-dashboards-filter-bar/my-dashboards-filter-bar';
import { MyDashboardList } from '../../../components/my-dashboard-list/my-dashboard-list';
import { useMyDashboardsFilters } from '../../../hooks/use-my-dashboard-filters';
import { useNavHeight } from '../../../../hooks/useNavHeight';

export const MyDashboardsTab = () => {
  const { navHeight } = useNavHeight();
  const { workspaceId = '', organisationId = '' } = useParams();
  const flags = useFlags();

  const view = useApiView(
    useMemo(() => new DashboardsListView(workspaceId, organisationId, false, flags), [workspaceId, organisationId, flags])
  );
  const { dashboards, isLoading } = view.state;

  const {
    searchTerm,
    onSearchChange,
    statusFilterValue,
    onStatusFilterChange,
    sortByFilterValue,
    onSortByFilterChange,
    filteredDashboards
  } = useMyDashboardsFilters(dashboards || [], organisationId, !!flags.resourceSharing);

  return (
    <>
      <ListingPageHeader
        variant="tab-header"
        title={<FormattedMessage id="predict.dashboards.dashboards_list" defaultMessage="Dashboards list" />}
        helpUrl="https://support.futrli.com/en/articles/14597299-my-dashboards"
        mb={0}
      />
      <MyDashboardsFilterBar
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        statusFilterValue={statusFilterValue}
        onStatusFilterChange={onStatusFilterChange}
        sortByFilterValue={sortByFilterValue}
        onSortByFilterChange={onSortByFilterChange}
        stickyTop={navHeight + LISTING_PAGE_TABS_HEIGHT}
        isResourceSharingEnabled={!!flags.resourceSharing}
      />
      <Box my={3}>
        <MyDashboardList
          data={filteredDashboards}
          isLoading={isLoading}
          isEmpty={(dashboards || []).length === 0}
          isResourceSharingEnabled={!!flags.resourceSharing}
        />
      </Box>
    </>
  );
};
